import { checkDate } from "common/helpers/Date";
import { Nullable } from "common/types";
import { Record } from "immutable";
import { DateStringNumber } from "common/records";

export const jobTypeFromJSON = (json: Partial<IJobTypeData>): JobTypeRecord => {
  const recordData: IJobTypeRecord = { ...(json as any) };
  if (json.created_at) {
    recordData.created_at = checkDate(json.created_at);
  }
  if (json.updated_at) {
    recordData.updated_at = checkDate(json.updated_at);
  }

  if (json.org_job_object_link) {
    recordData.org_job_object_link = orgJobTypeLinkFromJSON(json.org_job_object_link);
  }

  return new JobTypeRecord(recordData);
};

export const orgJobTypeLinkFromJSON = (json: Partial<IOrgJobTypeLinkData>): OrgJobTypeLinkRecord => {
  const recordData = { ...(json as any) };
  if (json.created_at) {
    recordData.created_at = checkDate(json.created_at);
  }
  if (json.updated_at) {
    recordData.updated_at = checkDate(json.updated_at);
  }
  return new OrgJobTypeLinkRecord(recordData);
};

export interface IOrgJobTypeLinkData {
  id: number;
  org_id: number;
  job_object_id: number;
  sort_order: number;

  created_at: DateStringNumber;
  updated_at: DateStringNumber;
}

export interface IJobTypeData {
  id: number;
  name: string;
  description: string;
  org_id: Nullable<number>;
  org_job_object_link: Nullable<IOrgJobTypeLinkData>;
  org_job_object_links_attributes?: IOrgJobTypeLinkData[];

  created_at: DateStringNumber;
  updated_at: DateStringNumber;

  loading?: boolean;
}

export interface IOrgJobTypeLinkRecord {
  id: number;
  org_id: number;
  job_object_id: number;
  sort_order: number;

  created_at: Date;
  updated_at: Date;
}

export interface IJobTypeRecord {
  id: number;
  name: string;
  description: string;
  org_id: Nullable<number>;
  org_job_object_link: Nullable<OrgJobTypeLinkRecord>;

  created_at: Date;
  updated_at: Date;

  loading: boolean;
}

export const defaultJobTypeProps = {
  id: 0,
  name: "",
  description: "",
  org_id: null,
  org_job_object_link: null,
  created_at: new Date(),
  updated_at: new Date(),
  loading: false,
};

export const defaultOrgJobTypeLinkProps = {
  id: 0,
  org_id: 0,
  job_object_id: 0,
  sort_order: 0,
  created_at: new Date(),
  updated_at: new Date(),
};

export class JobTypeRecord extends Record<IJobTypeRecord>(defaultJobTypeProps) implements IJobTypeRecord {}
export class OrgJobTypeLinkRecord
  extends Record<IOrgJobTypeLinkRecord>(defaultOrgJobTypeLinkProps)
  implements IOrgJobTypeLinkRecord {}
